import {Component, DestroyRef} from '@angular/core';
import {RouterLink} from "@angular/router";
import {BreadcrumbsService} from "@services/breadcrumbs.service";
import {AsyncPipe} from "@angular/common";

@Component({
    selector: 'app-breadcrumbs',
    imports: [
        RouterLink,
        AsyncPipe
    ],
    templateUrl: './breadcrumbs.component.html',
    styleUrl: './breadcrumbs.component.scss'
})
export class BreadcrumbsComponent {

    constructor(
        private destroyRef: DestroyRef,
        public breadcrumbsService: BreadcrumbsService
    )
    {
    }


}
